import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../components/v3";
import { AddEditReceivablesForm } from "../../components/client";

export const AddEditReceivables = () => {
  const { id } = useParams();
  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={id ? "Edit Payment" : "Add Payment"} />
      </Box>

      {/* form section */}
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <CardLayout>
          <AddEditReceivablesForm />
        </CardLayout>
      </Box>
    </PageLayout>
  );
};
